import { createApi } from '@reduxjs/toolkit/query/react';

import type { SamvalgsverktoyDto } from '../types/cms';

import type LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { CmsContentApiVersions } from '@helsenorge/framework-utils/cms-content-api-service';
import { getBaseQuery } from '@helsenorge/framework-utils/cms-content-api-service-redux';

const samvalgsverktoyApi = createApi({
  reducerPath: 'samvalgsverktoyApi',
  baseQuery: getBaseQuery,
  endpoints: builder => ({
    getSamvalgsverktoy: builder.query<SamvalgsverktoyDto, { verktoyNavn: string; language: LanguageLocales }>({
      query: ({ verktoyNavn, language }) => ['samvalgsverktoy', { navn: verktoyNavn, languageCode: language }, CmsContentApiVersions.V2],
    }),
  }),
});

export const { useGetSamvalgsverktoyQuery } = samvalgsverktoyApi;

export default samvalgsverktoyApi;
